var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'mm-badge': true,
    'mm-badge__standalone': !_vm.$slots.default,
  }},[_vm._t("default"),_c('sup',{class:{
      'mm-badge-content': true,
      'mm-badge-content__dot': _vm.dot,
      [`mm-badge-content--${_vm.status}`]: true,
      'mm-badge-content__zero': _vm.text === 0 && !_vm.showZero,
    }},[(!_vm.dot)?_c('span',[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }